var i18n = {
  'en-US': {
    'nav.tabs.home': 'Home',
    'nav.tabs.themeStore': 'Theme Store',
    'nav.tabs.myTheme': 'My Theme',
    'nav.tabs.changelog': 'ChangeLog',
    'common.upload.title': 'Image Crop',
    'theme.create.drawer.title': 'Create a theme',
    'theme.create.drawer.success': 'Theme created successfully',
    'theme.create.form.themeName': 'Theme Name',
    'theme.create.form.themeName.placeholder': 'Please enter',
    'theme.create.form.bytetree.nopermission': 'No permission,',
    'theme.create.form.bytetree.tip': 'Bind the current theme to the appropriate service tree node. If you do not have node authority or are unsure of the nodes that should be bound, you can consult business-related R&D students to bind service tree nodes',
    'theme.create.form.themeName.required': 'Theme name is required',
    'theme.create.form.description': 'Theme description ',
    'theme.create.form.space': 'Belong team space ',
    'theme.create.form.allow.text': 'Yes',
    'theme.create.form.description.maxLength': 'Enter up to 100 characters',
    'theme.create.form.depLibrary': 'UI framework',
    'theme.create.form.depVersion': 'Component library version',
    'theme.create.form.depVersion.tip1': '1. When configuring the theme, the component style will be previewed according to the configured version (the default is based on the latest version of the component library).',
    'theme.create.form.depVersion.tip2': '2. When the theme is released, it will be compiled according to the configured version, and the css file corresponding to the current version will be generated.',
    'theme.create.form.depVersion.option1': 'Always use the latest version',
    'theme.create.form.depVersion.option2': 'Select version',
    'theme.create.form.depVersion.required': 'Version must be selected',
    'theme.create.form.logo': 'Theme Logo ',
    'theme.create.form.cover': 'Theme cover ',
    'theme.create.form.cover.tip1': 'The cover image needs to emphasize the name of the theme',
    'theme.create.form.cover.tip2': 'The cover image should reflect the main color of the theme as much as possible',
    'theme.create.form.cover.tip3': 'The image ratio is 16:9',
    'theme.create.form.allowCopy': 'Allow others to copy',
    'theme.create.form.bytetree.node': 'Bytetree Node',
    'theme.create.form.allowCopy.tip': 'If checked, other users can create new themes with the current theme as a template',
    'theme.create.form.comfirm': 'Comfirm',
    'theme.create.form.cancel': 'Cancel',
    'themeCard.status.editing': 'Editing',
    'themeCard.status.published': 'Published',
    'themeCard.status.publishing': 'Publishing',
    'themeCard.status.deleted': 'Deleted',
    'themeCard.review.underReview': 'Under Review',
    'themeCard.review.unpassed': 'Review Failed',
    'themeCard.review.passed': 'Review passed',
    'themeCard.review.tobeReview': 'Tobe Review',
    'themeCard.message.deleted': 'Deleted',
    'themeCard.message.restore': 'It has been restored, you can return to the topic list to view',
    'themeCard.message.copyPkgName.success': 'Package name copied to clipboard',
    'themeCard.message.copyPkgName.error': 'Copy failed',
    'themeCard.preview.button.text': 'View',
    'themeCard.parent.preview.button.text': 'View parent theme',
    'themeCard.packageName.unpublish': 'Not yet published',
    'themeCard.dropdown.setting': 'Theme settings',
    'themeCard.dropdown.history': 'Version History',
    'themeCard.dropdown.confirm.delete.title': 'After deletion, it will not be viewable. Are you sure you want to delete?',
    'themeCard.dropdown.confirm.delete.btn': 'Delete',
    'themeCard.dropdown.confirm.restore.title': 'Are you sure about recovery?',
    'themeCard.dropdown.confirm.restore.btn': 'Restore',
    'themeEdit.drawer.title': 'Theme settings',
    'themeEdit.drawer.update.success': 'Edited successfully',
    'toggleTheme.theme.toLight': 'Click to use light mode',
    'toggleTheme.theme.light': 'Switch to light mode',
    'toggleTheme.theme.dark': 'Switch to dark mode',
    'toggleTheme.theme.toDark': 'Click to use dark mode',
    'nav.link.guideline': 'Guideline',
    'nav.action.viewDetail': 'View configuration details',
    'nav.action.preview': 'Preview',
    'nav.action.package.publish.update': 'Publish update',
    'nav.action.package.publish': 'Publish',
    'nav.action.copy.content': 'The current theme is not allowed to be copied',
    'nav.action.copy.btn': 'Copy theme',
    'nav.action.login': 'Login',
    'nav.action.back.preview': 'Back to preview',
    'design.menu.input.placeholder': 'Search for the keyword',
    'resetToken.title': 'Component reset confirmation',
    'resetToken.desc': 'After resetting the component, the previous settings for the component will be cleared and cannot be restored, please operate with caution!',
    'resetToken.btn.cancel': 'Cancel',
    'resetToken.btn.reset': 'Reset',
    'resetToken.success.tip': 'Reset!',
    'themePublish.title': 'Publish theme',
    'themePublish.version.info': 'Version info',
    'themePublish.version.desc': 'Version description',
    'themePublish.version.detail': 'Edit details',
    'themePublish.confirm': 'Publish',
    'themePublish.cancel': 'Cancel',
    'themePublish.publish.error': 'Publish error',
    'themePublish.publish.success': 'Publish successfully',
    'theme.package.name': 'Package name',
    'theme.package.version': 'Package version',
    'theme.package.depVersion': 'Component library version',
    'theme.package.beta': 'Used as a beta version',
    'theme.package.beta.text': 'Notice before checking',
    'theme.package.beta.tip1': "1. After the beta version is released, the system will automatically add the '-beta' suffix. The test package can reuse the \"version number\" that has been released, and the new \"version number\" proposed for the test version can be carried over to the official version.",
    'theme.package.beta.tip2': '2. After the test version is released, only the tag of the package will change, and the published modified content will always be used as the benchmark content of the next (official) version, and cannot be returned.',
    'theme.package.beta.tip3': 'For example: After `0.0.1-beta.1` is released, the next package release, whether it is an official version or a test version, is based on the content of `0.0.1-beta.1`.',
    'edit.history.reset.success': 'Successful operation',
    'edit.history.reset.batch.modal.title': 'Are you sure you want to undo the {total} selected edits? ',
    'edit.history.reset.btn': 'Batch undo',
    'edit.history.reset.undo': 'Undo',
    'edit.history.reset.undoing': 'Undoing...',
    'edit.history.reset.confirm': 'Confirm undo',
    'edit.history.reset.content': 'After revocation, the modified item will be restored to its original state, please operate with caution',
    'edit.history.reset.title': 'Are you sure you want to undo this modification?',
    'bytetree.notify.noremind': 'No mind in one day',
    'bytetree.notify.tipbind': 'Please bind the byte-tree node as soon as possible, otherwise the normal use of the team may be affected.',
    'bytetree.notify.bindnow': 'Bind now',
    'hawk.status.unpassed': 'The theme information contains sensitive information. Please modify it as soon as possible. The current theme cannot be viewed by others and cannot be configured before it is approved',
    'hawk.status.underReview': 'The theme is under review. The current theme cannot be viewed by others and cannot be configured before it is approved',
    'hawk.btn.updateNow': 'Update now',
    'theme.config.provider.trigger.btn': 'Config Provider',
    'theme.config.provider.trigger.tip1': '1. The effect of individual attributes cannot be displayed on the page due to priority or conditional restrictions, but it is not ineffective. The resulting product still has the associated configuration.',
    'theme.config.provider.trigger.tip2': '2. If you have any questions, please give feedback.'
  },
  'zh-CN': {
    'nav.tabs.home': '首页',
    'nav.tabs.themeStore': '主题商店',
    'nav.tabs.myTheme': '我的主题',
    'nav.tabs.changelog': '产品更新',
    'common.upload.title': '图片裁切',
    'theme.create.drawer.title': '创建主题',
    'theme.create.drawer.success': '主题创建成功',
    'theme.create.form.themeName': '主题名称',
    'theme.create.form.themeName.placeholder': '请输入',
    'theme.create.form.themeName.required': '必须填写主题名称',
    'theme.create.form.description': '主题描述',
    'theme.create.form.space': '归属项目',
    'theme.create.form.description.maxLength': '最多输入100个字',
    'theme.create.form.description.placeholder': '请输入',
    'theme.create.form.bytetree.nopermission': '没有权限，',
    'theme.create.form.depLibrary': 'UI 框架',
    'theme.create.form.depVersion': '组件库版本',
    'theme.create.form.depVersion.tip1': '1. 配置主题时将会根据所配置版本预览组件样式（默认根据最新版本的组件库）。',
    'theme.create.form.depVersion.tip2': '2. 主题发布时将会根据所配置版本进行编译，生成当前版本对应的css文件。',
    'theme.create.form.depVersion.option1': '始终使用最新版本',
    'theme.create.form.depVersion.option2': '选择版本',
    'theme.create.form.depVersion.required': '必须选择版本',
    'theme.create.form.logo': '主题Logo',
    'theme.create.form.cover': '主题封面',
    'theme.create.form.cover.tip1': '封面图需强调主题的名称',
    'theme.create.form.cover.tip2': '封面图尽量能体现主题的主色',
    'theme.create.form.cover.tip3': '图片比例为16:9',
    'theme.create.form.allowCopy': '允许他人复制',
    'theme.create.form.bytetree.node': '服务树节点',
    'theme.create.form.allowCopy.tip': '勾选后其他用户可以以当前主题为模板创建新的主题',
    'theme.create.form.comfirm': '确定',
    'theme.create.form.cancel': '取消',
    'themeCard.status.editing': '待发布',
    'themeCard.status.published': '已发布',
    'themeCard.status.publishing': '发布中',
    'themeCard.status.deleted': '已删除',
    'themeCard.review.underReview': '审核中',
    'themeCard.review.unpassed': '审核未通过',
    'themeCard.review.passed': '审核通过',
    'themeCard.review.tobeReview': '待审核',
    'themeCard.message.deleted': '已删除',
    'themeCard.message.restore': '已恢复，可以返回主题列表查看',
    'themeCard.message.copyPkgName.success': '包名已复制至剪贴板',
    'themeCard.message.copyPkgName.error': '复制失败',
    'themeCard.preview.button.text': '查看',
    'themeCard.parent.preview.button.text': '查看父主题',
    'themeCard.packageName.unpublish': '暂未发布',
    'themeCard.dropdown.setting': '主题设置',
    'themeCard.dropdown.history': '版本记录',
    'themeCard.dropdown.confirm.delete.title': '删除后将无法查看，确定删除？',
    'themeCard.dropdown.confirm.delete.btn': '删除主题',
    'themeCard.dropdown.confirm.restore.title': '是否确定恢复？',
    'themeCard.dropdown.confirm.restore.btn': '恢复主题',
    'themeEdit.drawer.title': '主题设置',
    'themeEdit.drawer.update.success': '编辑成功',
    'toggleTheme.theme.toLight': '点击切换为亮色模式',
    'toggleTheme.theme.light': '切换亮色模式',
    'toggleTheme.theme.dark': '切换暗黑模式',
    'toggleTheme.theme.toDark': '点击切换为暗黑模式',
    'nav.link.guideline': '帮助文档',
    'nav.action.viewDetail': '查看配置详情',
    'nav.action.preview': '预览',
    'nav.action.package.publish.update': '发布更新',
    'nav.action.package.publish': '发布',
    'nav.action.copy.content': '当前主题不允许被复制',
    'nav.action.copy.btn': '复制主题',
    'nav.action.login': '立即登录',
    'nav.action.back.preview': '返回预览',
    'design.menu.input.placeholder': '搜索关键字',
    'resetToken.title': '组件重置确认',
    'resetToken.desc': '重置该组件后，之前对于该组件的设置将被全部清空，且无法被复原，请谨慎操作！',
    'resetToken.btn.cancel': '取消',
    'resetToken.btn.reset': '重置',
    'resetToken.success.tip': '已重置！',
    'themePublish.title': '发布主题',
    'themePublish.version.info': '版本信息',
    'themePublish.version.desc': '版本描述',
    'themePublish.version.detail': '修改详情',
    'themePublish.confirm': '发布',
    'themePublish.cancel': '取消',
    'themePublish.publish.error': '发布失败',
    'themePublish.publish.success': '发布成功',
    'theme.package.name': '主题包名',
    'theme.package.version': '发布版本',
    'theme.package.depVersion': '组件库版本',
    'theme.package.beta': '用作测试版本',
    'theme.package.beta.text': '勾选须知',
    'theme.package.beta.tip1': "1、测试版本发布后，系统将自动添加'-beta'后缀。测试包可以重复使用已经发布过的「版本号」，同时为测试版本拟定的新「版本号」又可沿用到正式版本。",
    'theme.package.beta.tip2': '2、测试版本发包后，仅包的tag会发生变化，所发布的修改内容始终会作为下一（正式）版本的基准内容，且不可退回。',
    'theme.package.beta.tip3': '例如：发布 `0.0.1-beta.1` 后，接下来的一次发包，无论是 正式版本 还是 测试版本，皆以 `0.0.1-beta.1` 的内容为基准。',
    'edit.history.reset.success': '操作成功',
    'edit.history.reset.batch.modal.title': '确定撤销所选的 {total}个 修改项吗？',
    'edit.history.reset.btn': '批量撤销',
    'edit.history.reset.undo': '撤销',
    'edit.history.reset.undoing': '撤销中...',
    'edit.history.reset.confirm': '撤销',
    'edit.history.reset.content': '撤销后，该修改项将恢复至原状态，请谨慎操作',
    'edit.history.reset.title': '确认撤销该修改项吗？',
    'bytetree.notify.noremind': '一天内不再提示',
    'bytetree.notify.tipbind': '请尽快绑定团队的服务树节点，否则可能影响团队正常使用。',
    'bytetree.notify.bindnow': '立即绑定',
    'hawk.status.unpassed': '主题信息存在敏感信息，请尽快修改，在审核通过前当前主题无法被他人查看，且无法进行主题配置',
    'hawk.status.underReview': '主题正在审核中，在审核通过前当前主题无法被他人查看，且无法进行主题配置，审核时间预计 10 分钟，请耐心等待~ ',
    'hawk.btn.updateNow': '立即修改',
    'theme.create.form.bytetree.tip': '绑定当前主题到合适的服务树节点。如果没有节点权限或不确定应该绑定的节点，可咨询业务相关的研发同学进行服务树节点绑定',
    'theme.create.form.allow.text': '允许',
    'theme.config.provider.trigger.btn': '全局配置',
    'theme.config.provider.trigger.tip1': '1、个别属性由于优先级或者条件限制，效果无法在页面显示，并非不生效。',
    'theme.config.provider.trigger.tip2': '2、如有疑问烦请进行反馈。'
  }
};
export default i18n;